import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserDetailsService {

  userDetails : any = [];
  constructor() { }

  

  getUserDetails(){
    
    this.userDetails['token'] = localStorage.getItem('token');
    this.userDetails['user'] = localStorage.getItem('user');
    this.userDetails['accessKey'] = localStorage.getItem('accessKey');

    return this.userDetails;
    
  }

  setUserDetails(accessToken : string, user : string, accessKey : string){
    localStorage.setItem('token',accessToken);
    localStorage.setItem('user',user);
    localStorage.setItem('accessKey',accessKey);
  }

  getUserToken() : any{
    return localStorage.getItem('token');
  }

  getUser() : any{
    return localStorage.getItem('user');
  }

  destoryUserDetails(){
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('accessKey');
    localStorage.removeItem('auth_token');
  }

  getAccessKey() : any{
    return localStorage.getItem('accessKey');
  }

}